import DIContainer from 'services/DIContainer';
import { TIME_ZONE } from 'typings/common/date.enum';
import { EnterpriseResponseDTO } from 'typings/dto/enterprise';
import Mapper from './Mapper';
import { USER_POSITION } from 'typings/models/user.enum';

export default class EnterpriseMapper extends Mapper<Enterprise, EnterpriseResponseDTO> {
  constructor(private subEntitiesMappers: DIContainer.SubEntitiesMappers) {
    super({
      name: 'name',
      country: null,
      settings: 'settings',
      clientPricelistSettings: 'clientPricelistSettings',
      technicianPricelistSettings: 'technicianPricelistSettings',
    });
  }

  public responseDTOToModel = (dto: EnterpriseResponseDTO): Enterprise => {
    const defaultVisitInterval =
      dto.settings.order.visitIntervalSettings.defaultVisitInterval &&
      this.subEntitiesMappers.dateInterval.responseDTOToModel(
        dto.settings.order.visitIntervalSettings.defaultVisitInterval,
        'Zulu' as TIME_ZONE
      );
    const clientSmsInterval =
      dto.settings.order.clientSettings.clientSmsNotSendTime &&
      this.subEntitiesMappers.dateInterval.responseDTOToModel(dto.settings.order.clientSettings.clientSmsNotSendTime, 'Zulu' as TIME_ZONE);

    const outerMappers = this.getOuterMappers();
    return {
      ...this.responseDTOToModelViaDiffMap(dto),
      country: outerMappers.country.responseDTOToModel(dto.country),
      settings: {
        ...dto.settings,
        order: {
          ...dto.settings.order,
          visitInterval: {
            ...dto.settings.order.visitIntervalSettings,
            defaultVisitInterval,
          },
          clientSettings: {
            ...dto.settings.order.clientSettings,
            clientSmsNotSendTime: clientSmsInterval,
          },
          customFieldsSettings: {
            customFields: dto.settings.order.customFieldsSettings.customFields.map((i) =>
              this.subEntitiesMappers.orderCustomField.responseDTOToModel(i, outerMappers)
            ),
          },
          tabsVisibilitySettings: {
            configMap: Object.entries(dto.settings.order.tabsVisibilitySettings?.configMap ?? {}).reduce((acc, [key, value]) => {
              acc[key as USER_POSITION] = {
                hiddenTabs: new Set(value.hiddenTabs),
              };
              return acc;
            }, {} as Partial<Record<USER_POSITION, Enterprise.OrderTabsVisibilityConfig>>),
          },
        },
      },
    };
  };
}
